// routes
// import AppRouter from './routes/routes';
// theme
import ThemeProvider from './theme';
// components
import ScrollToTop from './components/scroll-to-top';
import { StyledChart } from './components/chart';
import AppRoutes from './routes/appRoutes';

export default function App() {
  return (
    <ThemeProvider>
      <ScrollToTop />
      <StyledChart />
      <AppRoutes />
    </ThemeProvider>
  );
}
